import request from "./request";
import { getCurrentUid } from "./web-h5-common";

/**
 * 获取 app 资源位配置
 * @param code 
 * @returns 
 */
export async function getResource(code: string | string[], params?: any) {
    console.log('获取资源位')
    const matchAdvert = '/v5/charge/advert/matchAdvertItem'; // 鉴权登录态
    const matchAdvertForGuest = '/v5/charge/advert/matchAdvertItemForGuest'// 不用登录态
    const userData = await getCurrentUid()
    let url = userData ? matchAdvert : matchAdvertForGuest
    return request(url, {
        positionCodeList: typeof code === 'string' ? [code] : code,
        bizParam: params || undefined
    }, 'POST')
}